import { UPLOADS_CHANGE, REFRESH_JOBLIST } from './../actions/uploadFilesChange';

const uploadFilesChangeReducer = (state = {}, { type, uploadFilesPayload }) => {
    switch (type) {
        case UPLOADS_CHANGE:
            return { ...state, uploadFilesPayload }
        case REFRESH_JOBLIST:
          return { ...state, uploadFilesPayload }
        default:
            return state
    }
};

const refreshJobListReducer = (state = {}, { type, refreshJobListPayload }) => {
  switch (type) {
      case REFRESH_JOBLIST:
        return { ...state, refreshJobListPayload }
      default:
          return state
  }
};

export { uploadFilesChangeReducer, refreshJobListReducer };